<template>
  <div class="invoice-view">
    <v-card flat v-if="isLoading">
      <v-card-text>
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </v-card-text>
    </v-card>
    <div v-else>
      <v-card flat>
        <ReportViewBar v-if="Invoice" :title="`Open Invoices`" />
        <v-btn depressed @click="loadData">
          Reload
        </v-btn>
        <v-container fluid>
          <table class="center">
            <tbody class="report-container">
              <v-card-text class="pt-0">
                <v-data-table dense :headers="headers" :itemsPerPage="Invoice.length" hide-default-footer
                  :items="Invoice">
                  <template v-slot:item="{ item }">
                    <tr>
                      <td class="text-left">
                        {{ item.date | moment("MM/DD/YYYY") }}
                      </td>
                      <td class="text-left">
                        {{ item.dueDate | moment("MM/DD/YYYY") }}
                      </td>
                      <td class="text-left">
                        <a href="#" @click="viewInvoice(item)">{{
                          item.localId
                        }}</a>
                      </td>
                      <td class="text-left">
                        <div v-if="item.Customer" @click="viewCustomerProfile(item.Customer)"><v-icon
                            color="green">mdi-account-outline</v-icon> {{
                              item.Customer.name }}
                          <v-chip color="yellow" v-if="item.Customer.payCompassId" small text-color="black">
                            <v-avatar left>
                              <v-icon small>mdi-checkbox-marked-circle</v-icon>
                            </v-avatar>
                            Online
                          </v-chip>
                        </div>
                        <div v-if="item.Donor" @click="viewDonorProfile(item.Donor)"><v-icon
                            color="red">mdi-hand-coin-outline</v-icon> {{ item.Donor.name }}
                          <v-chip color="yellow" v-if="item.Donor.payCompassId" small text-color="black">
                            <v-avatar left>
                              <v-icon small>mdi-checkbox-marked-circle</v-icon>
                            </v-avatar>
                            Online
                          </v-chip>
                        </div>
                      </td>
                      <td class="text-right">
                        {{ item.total | currency }}
                      </td>
                      <td class="text-right"
                        :class="{ 'red--text': item.due != item.total, 'font-weight-bold': item.due != item.total }">
                        {{ item.due | currency }}
                      </td>
                    </tr>
                  </template>
                  <template v-slot:body.append="{ headers }">

                    <tr :style="{ 'background-color': '#CFD8DC' }">
                      <td :colspan="headers.length - 2" class="text-right font-weight-bold">
                        Result Total
                      </td>
                      <td class="text-right font-weight-bold">
                        {{ fullTotalAmount | currency }}
                      </td>
                      <td class="text-right font-weight-bold">
                        {{ fullTotalDue | currency }}
                      </td>

                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </tbody>
          </table>
        </v-container>
      </v-card>
    </div>
  </div>
</template>

<script>
import ReportViewBar from "@/components/ReportViewBar";
import invoiceService from "@/modules/Invoice/service";
import { mapGetters, mapActions } from "vuex";
import Hashids from "hashids";
const hashids = new Hashids();

export default {
  data() {
    return {
      isLoading: true,
      Invoice: null,
      fullTotalAmount: 0,
      fullTotalDue: 0,
      headers: [
        {
          text: "DATE",
          align: "left",
          value: "date",
          sortable: true,
        },
        {
          text: "DUE DATE",
          align: "left",
          value: "date",
          sortable: true,
        },
        {
          text: "ID",
          align: "left",
          value: "qty",
          sortable: false,
        },
        {
          text: "NAME",
          align: "left",
          sortable: false,
        },
        {
          text: "AMOUNT",
          align: "right",
          value: "rate",
          sortable: false,
        },
        {
          text: "BALANCE",
          align: "right",
          value: "total",
          sortable: false,
        },
      ],
      totalQty: 0,
    };
  },
  computed: {
    ...mapGetters("global", ["currentBusiness"]),
    total() {
      let total = 0;
      this.Invoice.map((row) => {
        total += row.price;
      });

      return total;
    },
  },
  created() {
    this.loadData();
    // if (!this.currentBusiness) this.initUser();
  },
  components: { ReportViewBar },
  methods: {
    ...mapActions("global", ["initUser", "initBusiness"]),
    viewCustomerProfile(val) {
      window.open(`/parents/${val.id}/profile`, '_blank');
      // this.$router.push({ path: `/parents/${val.id}/profile` });
    },
    viewDonorProfile(val) {
      window.open(`/donors/${val.id}/profile`, '_blank');
      // this.$router.push({ path: `/parents/${val.id}/profile` });
    },
    viewInvoice(invoice) {
      if (invoice.DonorId) {
        this.donorInvoice(invoice)
      } else {
        this.openInvoice(invoice)
      }
    },
    openInvoice(invoice) {
      console.log('invoice', invoice.id)
      const hashId = hashids.encode(invoice.id);
      console.log('dueAmount', `localhost:8082/global/invoice/${hashId}/view`)
      const routeData = this.$router.resolve({
        path: `/global/invoice/${hashId}/view`,
      });
      window.open(routeData.href, "newwindow", "width=850, height=1100");
    },
    donorInvoice(invoice) {
      console.log('invoice', invoice.id)
      const hashId = hashids.encode(invoice.id);
      const routeData = this.$router.resolve({
        path: `/global/invoice/${hashId}/donorInvoice`,
      });
      window.open(routeData.href, "newwindow", "width=850, height=1100");
    },
    loadData() {
      this.isLoading = true

      const where = {
        due: true,
      };

      return invoiceService.getAll(where).then((response) => {
        console.log("invoice", response);
        this.Invoice = response.data;
        this.count = response.count;
        this.fullTotalAmount = 0
        this.fullTotalDue = 0
        this.Invoice.map(row => {
          this.fullTotalAmount += row.total
          this.fullTotalDue += row.due
        })
        // this.business = response.business;
        this.isLoading = false
        return response;
      });

    },
  },
};
</script>

<style scoped>
@media print {
  container {
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }

  .no-print {
    display: none;
  }

  .detailBox {
    overflow: visible;
    height: 100%;
  }

  * {
    background: 0 0 !important;
    color: #000 !important;
    box-shadow: none !important;
    text-shadow: none !important;
  }
}

.paidImg {
  position: absolute;
  left: 40%;
  top: 10%;
}

.signature {
  margin-top: 100px;
}

.center {
  background-color: white;
  margin: auto;
  width: 100%;
}
</style>
